"use strict";

import { cxAlwaysInTouchConstants } from "../_constants";

export const INITIAL_CX_ALWAYS_IN_TOUCH_STATE = {
     winnerList : { winners: [], totalCount: 0, page: 1, pageSize: 10 },
     winnerFilterOptions : { months: [], dealers: [], areas: [] },
     jobRoles : [],
     winnersExport : null,
     addWinnersResult : null,
};

export function cxAlwaysInTouch(state = INITIAL_CX_ALWAYS_IN_TOUCH_STATE, action) {
    switch (action.type) {
     case cxAlwaysInTouchConstants.CX_GET_WINNERS_COMPLETE:
          return {
               ...state,
               winnerList: action.payload,
          };
     case cxAlwaysInTouchConstants.CX_GET_WINNER_FILTER_OPTIONS_COMPLETE:
          return {
               ...state,
               winnerFilterOptions: action.payload,
          };
     case cxAlwaysInTouchConstants.CX_GET_JOB_ROLES_COMPLETE:
          return {
               ...state,
               jobRoles: action.payload,
          };
     case cxAlwaysInTouchConstants.CX_GET_WINNERS_EXPORT_COMPLETE:
          return {
               ...state,
               winnersExport: action.payload,
          };
     case cxAlwaysInTouchConstants.CX_CLEAR_WINNERS_EXPORT:
          return {
               ...state,
               winnersExport: null,
          };
     case cxAlwaysInTouchConstants.CX_ADD_WINNERS_COMPLETE:
          return {
               ...state,
               addWinnersResult: action.payload,
          };
     case cxAlwaysInTouchConstants.CX_CLEAR_ADD_WINNERS_RESULT:
          return {
               ...state,
               addWinnersResult: null,
          };
     default:
          return state;
    }
}
